export const BRAND_NAME = "ClawWrapper";
export const PROJECT_NAME = "clawwrapper";
export const SITE_DOMAIN = "clawwrapper.pro";
export const SITE_URL = "https://clawwrapper.pro";
export const SUPPORT_EMAIL = "support@clawwrapper.pro";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
